import { RowSelectionItem } from 'app/shared/features/map-row-selector/models';

export interface RowSelectionState {
    rows: RowSelectionItem[];
    selectionProgressState: SelectionProgressState;
}

export const initialRowSelectionState: RowSelectionState = {
    rows: [],
    selectionProgressState: 'not-started',
};

export type SelectionProgressState = 'not-started' | 'in-progress' | 'finished';
